import { Dialog, DialogPanel } from "@headlessui/react";
import { X } from "lucide-react";
import cancelIcon from "../../../../assets/images/cancelArrow.svg";
import React from "react";
import useRTLContext from "../../../../hooks/useRTLContext";
import { useTranslation } from "react-i18next";

const StatusModal = ({
  icon,
  headline,
  headlineData = {},
  onConfirm,
  confirmText,
  paraText,
  paraTextData = {},
  buttonText,
  isOpen,
  onClose,
  isSuccess = false, // true for success, false for failed
}) => {
  const { isRTL, direction } = useRTLContext();
  const { t, i18n } = useTranslation();

  // Handle translation if paraTextData has moduleText
  const message = paraTextData.moduleText
    ? (() => {
        const translatedModule = t(`${paraTextData.moduleText}`);
        return t(paraText, {
          ...paraTextData,
          moduleText: translatedModule,
        });
      })()
    : t(paraText, paraTextData);

  return (
    <Dialog open={isOpen} onClose={onClose} className="fixed z-[999999]">
      <div className="fixed inset-0 bg-[#04080B59]" aria-hidden="true" />
      <div className="fixed inset-0 flex items-center justify-center lg:justify-center overflow-y-auto">
        <div className="flex items-center justify-center min-h-screen overflow-y-auto p-4">
          <DialogPanel className="bg-white w-[920px] mx-auto rounded-lg shadow-lg p-6 pt-[8px] pe-[8px]">
            <div className="flex justify-end">
              <div
                className="flex justify-center w-[40px] h-[40px] rounded align-middle bg-[#F2F4F7] cursor-pointer"
                onClick={onClose}
              >
                <img
                  src={cancelIcon || "/placeholder.svg"}
                  alt="cancel icon"
                  className="w-[24px]"
                />
              </div>
            </div>
            <div className="flex items-center justify-start mb-6">
              <div className="">{icon}</div>
            </div>
            <h2 className="text-2xl text-[#04080B] font-bold mb-2">
              {t(headline, {
                module: t(headlineData.module),
              })}
            </h2>
            <p className="text-[#04080B] mb-6 font-medium text-[14px] leading-[160%] tracking-[0%]">
              {message}
            </p>
            <div className="flex py-4 border-t-[1px] border-gray-300 justify-start gap-3">
              {/* Single button with conditional styling based on success/failed */}
              <button
                className={`px-6 py-2 font-bold rounded text-white 
                  ${
                    isSuccess
                      ? "bg-[#027A48] hover:bg-green-600" // Green for success
                      : "bg-[#B42318] hover:bg-red-600" // Red for failed
                  }`}
                onClick={onConfirm}
              >
                {t(confirmText)}
              </button>
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  );
};

export default StatusModal;
